import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { toRem } from "theme/Breakpoints";
import { shadow } from "theme/GlobalElements";
import { colors } from "theme/Theme";
import { DefaultText } from "theme/GlobalElements";
import { useDispatch, useSelector } from "react-redux";
import { selectActiveFilters, selectFilters, selectMaxPrice } from "../filtersSlice";
import { useDebounce } from "hooks/useDebounce";
import { SortingType } from "pages/category/types";
import { PageWithFilterType, ActiveFilter } from "../types";
import { useSetFilters } from "hooks/useSetFilters";
import { setPage } from "features/pagination/paginationSlice";
import { useLocation } from "react-router";
import Button, { buttonType } from "components/Button/Button";
import { withStyles, Slider } from "@material-ui/core";
import { Input } from "features/payment/paymentPageStyles";
const PriceSlider = withStyles({
  root: {
    alignSelf: "center",
    width: "95%",
  },
  track: {
    color: "#0098ff",
  },
  thumb: {
    color: "#0098ff",
  },
})(Slider);

interface FilterPricingProps {
  pageType: PageWithFilterType;
  reset: boolean;
  fetchFN: (activefilters: ActiveFilter[], page: number, sortingType: SortingType) => void;
}
// const maxVal = 10000;
const FilterPricing: React.FC<FilterPricingProps> = ({ pageType, reset, fetchFN }) => {
  const setFilter = useSetFilters("price", pageType, fetchFN);
  const maxVal = useSelector(selectMaxPrice); //TODO: mahai go ako nqma bygowe do 1 sedmica :D
  const multiplier = ~~(maxVal / 100);

  // const activeFilters = useSelector(selectActiveFilters);
  // const activePrices = activeFilters
  //   .find((i) => i.name === "price")
  //   ?.activeFilters[0]?.split(",");
  const [from, setFrom] = useState<any>("");
  const [to, setTo] = useState<any>("");
  const [searchTerm, setSearchTerm] = useState("");
  const debouncedSearchTerm = useDebounce(searchTerm, 500);
  // const location = useLocation();
  const params = new URLSearchParams(window.location.search);
  const queryPrices = params.get("price");

  const dispatch = useDispatch();
  useEffect(() => {
    setFrom("");
    setTo("");
    setSearchTerm("");
  }, [reset, window.location.pathname]);

  useEffect(() => {
    const arr = queryPrices?.split(",");
    if (arr) {
      if (from !== arr[0]) setFrom(arr[0]);
      if (to !== arr[1]) setTo(arr[1]);
    } else {
      setFrom("");
      setTo("");
    }
  }, [queryPrices]);

  useEffect(() => {
    if (debouncedSearchTerm) {
      //&&  ((+from > 0 && +to > 0 && +from < +to) || (+from > +to && +to === 0) || (+from === +to && +from >= 0))) {
      setFilter(debouncedSearchTerm);
      dispatch(setPage(1));
    }
  }, [debouncedSearchTerm]);

  // const onClick = () => {
  //   // if (from !== prices[0] || to !== prices[1]) {
  //   if (+to === 0 || +to < +from) {
  //     // if (activePrices &&(+activePrices[0] !== +from)) {
  //     setSearchTerm(`${+from},${prices[1]}`);
  //     // }
  //   } else {
  //     setSearchTerm(`${+from},${+to}`);
  //   }
  //   // }
  // };

  const search = (fromVal: any, toVal: any) => {
    if (+toVal === 0 || +toVal < +fromVal) {
      setSearchTerm(`${+fromVal},${maxVal}`);
    } else {
      setSearchTerm(`${+fromVal},${+toVal}`);
    }
  };

  const onFromChange = (event: any) => {
    var newVal = event.target.value;
    if (+newVal < 0 || (+newVal > +to && +to !== 0)) return;
    setFrom(newVal);
    search(newVal, to);
  };

  const onToChange = (event: any) => {
    var newVal = event.target.value;
    if (+newVal < 0) return;
    setTo(newVal);
    search(from, newVal);
  };

  const handleChange = (event: any, newValue: any) => {
    const _from = newValue[0] * multiplier;
    const _to = newValue[1] * multiplier;

    setFrom(_from);
    setTo(_to);
    search(_from, _to);
  };

  return (
    <FilterPricingContainer>
      <Inputs>
        <PriceInput>
          <DefaultText fontWeight={"bold"} style={{ letterSpacing: "1px" }}>
            Цена от (€):
          </DefaultText>
          <FilterInput type="number" value={from} onChange={onFromChange} />
        </PriceInput>
        <PriceInput>
          <DefaultText fontWeight={"bold"} style={{ letterSpacing: "1px" }}>
            Цена до (€):
          </DefaultText>
          <FilterInput type="number" value={to} onChange={onToChange} />
        </PriceInput>
      </Inputs>
      <PriceSlider
        value={[from / multiplier, to / multiplier]}
        onChange={handleChange}
        valueLabelDisplay="off"
        aria-labelledby="range-slider"
      />
      {/* <SearchButton>
        <Button rounded={false} type={buttonType.blueBtn} onClick={onClick} title="Търси" />
      </SearchButton> */}
    </FilterPricingContainer>
  );
};

const FilterPricingContainer = styled.div`
  width: 100%;
  background-color: ${colors.gray};
  ${shadow};
  margin-bottom: 20px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
`;
const SearchButton = styled.div`
  ${shadow};
  margin-top: 20px;
  margin-bottom: 10px;
`;

const Inputs = styled.div`
  justify-content: space-between;
  display: inline-flex;
`;
const PriceInput = styled.div`
  justify-content: space-between;
  display: flex;
  flex-direction: column;
  margin: 5px;
  & > * {
    margin-bottom: 3px;
  }
`;
const FilterInput = styled(Input)`
  width: ${toRem(100)};
`;
export default FilterPricing;
